import config from 'js/app/config';

import { resolveBreadcrumbTrail } from 'bundles/page/utils/breadcrumbTrailUtils';
import type { BreadcrumbListItem } from 'bundles/seo/utils/schemaMarkupUtils';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

export type LearningPathBreadcrumbTrailArgs = {
  orgSlug?: string;
  programSlug?: string;
};

export type LearningPathBreadcrumbSegment = {
  name: string;
  href: string;
};

export const getLearningPathBreadcrumbSegments = ({
  orgSlug,
  programSlug,
}: LearningPathBreadcrumbTrailArgs): Array<LearningPathBreadcrumbSegment> => {
  let scopeRoot;

  if (orgSlug) {
    scopeRoot = `/organizations/${orgSlug}`;
  } else if (programSlug) {
    scopeRoot = `/programs/${programSlug}`;
  }

  if (!scopeRoot) {
    return [];
  }

  return [
    { name: _t('Home'), href: scopeRoot },
    { name: _t('Categories'), href: `${scopeRoot}/browse` },
  ];
};

export const getLearningPathBreadcrumbListItems = (args: LearningPathBreadcrumbTrailArgs): Array<BreadcrumbListItem> =>
  resolveBreadcrumbTrail(getLearningPathBreadcrumbSegments(args), config.url.base);
